import { render, staticRenderFns } from "./PostCode.vue?vue&type=template&id=2cf86733&scoped=true&"
import script from "./PostCode.vue?vue&type=script&lang=js&"
export * from "./PostCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf86733",
  null
  
)

export default component.exports